// GAP: no spacing token for the 52px top bar (the design's height).
export const HEADER_HEIGHT = "3.25rem";
/** Menu-row icon size in the story Share menu (design: 15px). */
export const SHARE_ICON_SIZE = 15;
